export default "__VITE_ASSET__8A0y$f0V__"